module.exports = __webpack_public_path__ + "img/video-pic6.e013277e.jpg";